import { SDK_VERSION as SENTRY_REACT_VERSION } from '@sentry/react';

export const SENTRY_EXPO_PACKAGE = 'npm:sentry-expo';
export const SENTRY_EXPO_VERSION = '7.2.0';

export const SENTRY_REACT_NATIVE_PACKAGE = 'npm:@sentry/react-native';
export const SENTRY_REACT_PACKAGE = 'npm:@sentry/react';
export { SENTRY_REACT_VERSION };
